import React from "react";

import { PageWithAuth } from "@mcp/interfaces";
import { NextPage } from "next";
import dynamic from "next/dynamic";

const StartCasePage = dynamic(() => import("@/containers/cases/StartCase"), {
  ssr: false,
});

const StartCase: PageWithAuth<NextPage> = () => {
  return <StartCasePage />;
};

StartCase.auth = true;
export default StartCase;
